import React from 'react';
import { observer } from 'mobx-react';
import dashboardSettingsStore from '../../../../stores/dashboard-settings-store';
import TermsAcceptanceModal from '../../../../pages/home/components/terms-acceptance-modal/terms-acceptance-modal';
import { PROFILE_CAPABILITIES } from '../../../../models/ProfileCapabilities';

const TermsAcceptanceModalGate: React.FC = observer(() => {
    const handleAccept = () => dashboardSettingsStore.acceptTerms();

    if (!dashboardSettingsStore.areSettingsLoaded) {
        return null;
    }

    const termsAcceptance = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.TERMS_ACCEPTANCE);

    if (
        !termsAcceptance?.isSupported
        || !dashboardSettingsStore.termsAcceptanceRequired
        || dashboardSettingsStore.isSuperAdmin
        || dashboardSettingsStore.isOnboardingWizardShown
        || !dashboardSettingsStore.termsContent
    ) {
        return null;
    }

    return (
        <TermsAcceptanceModal
            termsContent={dashboardSettingsStore.termsContent}
            onAccept={handleAccept}
        />
    );
});

export default TermsAcceptanceModalGate;
